export default "__VITE_ASSET__ll7pxBYs__"